class UnloadConfirmation {
  constructor() {
    this.isUnloadConfirmationEnabled = false;
    this.confirmationMessage = this.confirmationMessage.bind(this);
  }

  enable() {
    if (!this.isUnloadConfirmationEnabled) {
      this.isUnloadConfirmationEnabled = true;
      $(window).on('beforeunload', this.confirmationMessage);
    }
  }

  disable() {
    if (this.isUnloadConfirmationEnabled) {
      this.isUnloadConfirmationEnabled = false;
      $(window).off('beforeunload', this.confirmationMessage);
    }
  }

  isActive() {
    return this.isUnloadConfirmationEnabled;
  }

  confirmationMessage(event) {
    // 一部の古いバージョンのブラウザではカスタムメッセージが表示される。現代のブラウザではブラウザの標準メッセージが表示される
    const message = '行った変更が保存されない可能性があります。';
    // 一部の古いバージョンのブラウザでは、event.returnValueを設定する必要がある
    event.returnValue = message;
    return message;
  }
}

export default UnloadConfirmation;
